module.exports = __webpack_public_path__ + "static/media/5.30fee9db.jpg";